<template>
  <div class="admin-order">

    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" to="/orders">我的订单</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/admin-order'">查看本店全部订单</router-link>
    </div>

    <!-- 过滤 -->
    <el-form :model="params" label-width="75px" :inline="true" class="search">

      <el-select v-model="params.peer_account_id" placeholder="负责成员" class="responsible-member" @change="searchOrReset(1)">
        <el-option label="全部" value="0"></el-option>
        <el-option v-for="account in accounts" :key="account.peer_account_id" :label="account.name" :value="account.peer_account_id"></el-option>
      </el-select>

      <el-select v-model="params.order_status" placeholder="订单状态" class="order-status" @change="searchOrReset(1)">
        <el-option label="全部" value="-1"></el-option>
        <el-option label="已取消" value="0"></el-option>
        <el-option label="待上传资料" value="1"></el-option>
        <el-option label="待填写申请表" value="2"></el-option>
        <el-option label="待选择赴馆日期" value="10"></el-option>
        <el-option label="待支付" value="3"></el-option>
        <el-option label="待邮寄资料" value="4"></el-option>
        <el-option label="办理中" value="5"></el-option>
        <el-option label="已发货" value="6"></el-option>
        <el-option label="待评价" value="7"></el-option>
        <el-option label="已完成" value="8"></el-option>
        <el-option label="已删除" value="9"></el-option>
      </el-select>

      <el-select v-model="params.applicant_status" @change="searchOrReset(1)" clearable placeholder="申请人状态" class="search-date">
        <el-option v-for="(v,k) in $maps.APPLICANT_STATUS" :label="v" :key="k" :value="k.toString()">
        </el-option>
      </el-select>

      <el-date-picker class="pay-time"
        @change="searchOrReset(1)"
        v-model="params.pay_time"
        type="daterange"
        range-separator=" ~ "
        :editable="false"
        placeholder="支付时间"></el-date-picker>

      <div class="search-row">
        <el-input class="search-condition"  v-on:keyup.native.enter="searchOrReset(1)" v-model="params.condition" placeholder="订单号、申请人姓名、收件人手机号、商品名称、飞猪订单编号等"></el-input>
        <el-button type="primary" class="button" @click="searchOrReset(1)">查询</el-button>
        <el-button type="default" class="button" @click="searchOrReset(1, true)">重置</el-button>
      </div>

    </el-form>

    <!-- 订单栏 -->
    <div class="list-box" v-if="orders && orders.length > 0">
      <div class="list-top">
        <div class="order-count">
          共查询到 {{count.total_count}} 个订单，办理签证 <span>{{count.visa_count}}</span> 本，金额总计 <span>{{count.total_amount / 100}}</span> 元
        </div>

        <!-- 订单导出按钮 -->
        <export-btn class="export-btn" text="导出到本地" @exportFn="exportOrderList"></export-btn>
      </div>
      

      <order-item v-for="(item, index) in orders" :key="index" :order="item"></order-item>
    </div>

    <el-pagination v-if="orders && orders.length" class="page-box" @current-change="searchOrReset"
      :current-page="params.page" :page-size="10" layout="prev, pager, next" :total="count.total_count">
    </el-pagination>
  </div>
</template>

<script>
import moment from 'moment';
import orderItem from '../components/order-item';
import Http from '../libs/http';
import ExportBtn from '@/components/common/export-btn.vue';
import { ORDER_ENABLE_API_MAP } from '@/maps/order-maps';

export default {
  name: 'adminOrder',
  components: {
    orderItem,
    ExportBtn,
  },
  data() {
    return {
      orders: [],
      accounts: [],
      count: {}, // 实际的内容写在下面的reset方法里面了
      params: {}, // 实际的内容写在下面的reset方法里面了
    };
  },
  watch: {

    // 在改变query的时候重新加载数据
    $route() {
      this.resetResponseData();
      this.getOrderData();
    },
  },
  methods: {

    // 重置响应数据
    resetResponseData() {
      this.orders = [];
      this.count = {
        visa_count: 0,
        total_amount: 0,
        total_count: 0,
      };
    },

    // 重置参数
    resetParams() {
      this.params = {
        peer_account_id: '',
        order_status: '',
        applicant_status: '',
        pay_time: [],
        condition: '',
        // ota_id: '',
        page: 1,
      };
    },

    // 获取实际数据
    getParams(page, reset) {
      if (reset) {
        this.resetParams();
      }
      return reset ? { page } : this.createParams(this.params);
    },

    // 查询或者重置
    searchOrReset(page, reset) {
      this.params.page = page;
      const params = this.getParams(page, reset);
      this.$router.push({ path: '/admin-order', query: params });
    },

    // 获取数据
    getOrderData() {
      const params = this.createParams(this.params);
      Http.post('/order_brief_query_admin', params).then((data) => {
        // 无情的从getter,setter变为普通对象
        if (data.page_data) {
          JSON.parse(JSON.stringify(data.page_data)).forEach((order, index) => {
            order.isExpand = Boolean(params.condition);
            data.page_data[index] = order;
          });
        }
        this.orders = data.page_data;
        this.count.total_count = data.total_count;
        this.count.visa_count = data.visa_count;
        this.count.total_amount = data.total_amount;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 使用路由参数设置data中的参数对象
    setParamsInDataByRouteParams() {
      this.params.page = this.$route.query.page ? +this.$route.query.page : 1;

      this.params.peer_account_id = this.$route.query.peer_account_id ?
        +this.$route.query.peer_account_id : this.params.peer_account_id;

      this.params.order_status = this.$route.query.order_status ?
        this.$route.query.order_status : this.params.order_status;

      this.params.applicant_status = this.$route.query.applicant_status ?
        this.$route.query.applicant_status : this.params.applicant_status;

      this.params.condition = this.$route.query.condition ?
        this.$route.query.condition : this.params.condition;

      // this.params.ota_id = this.$route.query.ota_id ? +this.$route.query.ota_id : this.params.ota_id;

      if (this.$route.query.begin_date && this.$route.query.end_date) {
        this.params.pay_time = [
          new Date(this.$route.query.begin_date),
          new Date(this.$route.query.end_date),
        ];
      }
    },

    // 创建参数对象
    createParams(params) {
      const data = { page: this.params.page };

      if (+params.peer_account_id) {
        data.peer_account_id = +params.peer_account_id;
      }
      if (params.order_status !== '' && +params.order_status > -1) {
        data.order_status = +params.order_status;
      }

      if (params.applicant_status !== '' && +params.applicant_status > -1) {
        data.applicant_status = +params.applicant_status;
      }

      if (params.condition) {
        data.condition = params.condition;
      }
      if (params.pay_time && params.pay_time[0]) {
        data.begin_date = moment(params.pay_time[0]).format('YYYY-MM-DD');
        data.end_date = moment(params.pay_time[1]).format('YYYY-MM-DD');
      }
      /* if (params.ota_id) {
        data.ota_id = +params.ota_id;
      } */
      return data;
    },

    // 获取账户数据
    getAccountData() {
      Http.post('/peer_account_total_query').then((data) => {
        this.accounts = data.result;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 订单导出
    async exportOrderList(callback = () => {}) {
      const params = this.createParams(this.params);
      Object.assign(params, {
        page: undefined,
        is_query_all: 1, //  0-查询订单列表下的导出 1-查看本店所有订单下的导出
      });

      try {
        const { total_data } = await Http.post('/order_export', params);

        let exportData = [];
        if (total_data) {
          exportData = total_data.map(item => ({
            ...item,
            enable_api: ORDER_ENABLE_API_MAP[item.enable_api],
            total_amount: item.total_amount / 100,
            pay_amount: item.pay_amount / 100,
            actual_pay_amount: item.actual_pay_amount / 100,
            discount_amount: item.discount_amount / 100,
          }));
        }
        callback(exportData, {
          user_order_id: '订单号',
          country: '商品目的地',
          product_name: '商品全称',
          total_amount: '订单总金额',
          pay_amount: '应支付金额',
          actual_pay_amount: '实付金额',
          discount_amount: '优惠金额',
          order_status_desc: '订单状态',
          enable_api: 'API订单', // 0 ,1 
          pay_time: '订单支付时间',
          applicant_name: '申请人',
          applicant_count: '申请人数量',
          applicant_status_desc: '申请人状态',
        }, `订单列表_${moment(new Date()).format('YYYYMMDDHHmmss')}.xlsx`);

      } catch (e) {
        callback(); // 防止按钮一直加载
        console.log(e);
      }
    },
  },
  created() {
    this.getAccountData();
    this.resetResponseData();
    this.resetParams();
    this.setParamsInDataByRouteParams();
    this.getOrderData();
  },
};
</script>

<style lang="less" scoped>
@import  '../assets/less/variable';
.admin-order {
  width: 1000px;
  margin: 0 auto 65px auto;
  .search{
    padding:20px;
    background-color: @color-eaf3ff;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    >div {
      margin-right: 20px;
      margin-bottom: 14px;
    }
    .search-row {
      width: 100%;
      display: flex;
      margin-bottom: 0;
    }
    .search-row >div {
      margin-right: 20px;
    }
    .search-condition {
      width: 750px;
    }
    .button {
      width: 80px;
      margin-right: 20px;
      margin-left: 0;
    }
  }
  .list-box {
    padding: 20px;
    background: #fff;
    .list-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .export-btn {
        flex-shrink: 0;
      }
    }
    .order-count {
      flex: 1;
      font-size: 12px;
      color: #aaa;
      span {
        color: #fc7906;
      }
    }
  }
  .page-box {
    background-color: @white;
    text-align: center;
    padding-bottom: 40px;
  }
}
</style>

<style lang="less">
.responsible-member .el-input {
  width: 220px;
}

.order-status .el-input {
  width: 220px;
}

.pay-time .el-input,
.search-date .el-input {
  width: 220px;
}
</style>




// WEBPACK FOOTER //
// src/pages/AdminOrder.vue